import { axiosPost } from "./ajaxServices";
import {
  urlGetUnitList,
  urlGetAllUnits,
  urlCreateUnit,
  urlUpdateUnit,
  urlDeleteUnit,
} from "./CONSTANTS";

const config = { headers: { "content-type": "multipart/form-data" } };

export const apiGetUnitList = () => {
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(urlGetUnitList, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Active-only units for dropdowns (variant editor, zone editor).
export const apiGetAllUnits = () => {
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(urlGetAllUnits, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const appendUnitFields = (formData, unit) => {
  formData.append("name", unit.name || "");
  formData.append("is_base", unit.is_base ? "1" : "0");
  if (unit.is_base) {
    formData.append("is_weight_base", unit.is_weight_base ? "1" : "0");
  } else {
    formData.append("base_unit_id", unit.base_unit_id ?? "");
    formData.append("factor", unit.factor ?? 1);
  }
  formData.append("status", unit.status ? "1" : "0");
};

export const apiCreateUnit = (unit) => {
  var formData = new FormData();
  appendUnitFields(formData, unit);
  return new Promise((resolve, reject) => {
    axiosPost(urlCreateUnit, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiUpdateUnit = (id, unit) => {
  var formData = new FormData();
  formData.append("id", id);
  appendUnitFields(formData, unit);
  return new Promise((resolve, reject) => {
    axiosPost(urlUpdateUnit, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiDeleteUnit = (id) => {
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(urlDeleteUnit, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
